export const Colors = {
  JPVioletMain: '#8C3CFA',
  JPViolet1: '#9B5FF5',
  JPViolet2: '#C8A0F0',
  JPViolet3: '#4600B4',
  JPViolet4: '#6919D7',
};
